const siderBar = {
  profile: "الملف الشخصي",
  history: "السجل",
  setting: "الإعدادات",
  promotion: "ترويج",
};

export default siderBar;